import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useFoundrSpaceAnalytics } from "./foundrspace_analytics";
import { partnerConfig } from "./foundrspace_partner_config";

const Theme = lazyWithRetry(() => import("./foundrspace_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 9", value: { minCapacity: 1, maxCapacity: 9 } },
  { label: "10+", value: { minCapacity: 10 } },
];

export function OfferingFoundrSpaceListingMeetingRoom() {
  useFoundrSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting Rooms",
          description:
            "Your team meetings just got better. Need to meet in a pinch? We have different conference rooms of all sizes on standby for your next meeting.",
        }}
      />
    </Fragment>
  );
}
